import * as React from "react";
import { UitkCardAloha } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkFigure, UitkImage, UitkFigureAspectRatioType } from "uitk-react-images";
import { AttachSavingsCardProps } from "../typings";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "../l10n";
import { SavingsContent } from "./SavingsContent";

export const AttachSavingsCard = ({
  padded,
  withBorder,
  deepLink,
  deepLinkMipType,
  percentageOff,
  moduleName,
}: AttachSavingsCardProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkCardAloha padded={padded} border={withBorder} className="attachSavingsCard">
      <UitkLayoutFlex alignItems="center">
        <UitkLayoutFlexItem minWidth="third_width" className="all-x-padding-twelve s-x-padding-six">
          <div>
            <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
              <UitkImage
                alt={formatText(locKeys.savingsTitle)}
                src="https://a.travel-assets.com/flex/flexmanager/images/2019/11/21/illustration__treasure__sml.svg"
              />
            </UitkFigure>
          </div>
        </UitkLayoutFlexItem>

        <UitkLayoutFlexItem>
          <div>
            <SavingsContent
              deepLink={deepLink}
              deepLinkMipType={deepLinkMipType}
              moduleName={moduleName}
              percentageOff={percentageOff}
            />
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </UitkCardAloha>
  );
};

export default AttachSavingsCard;
